// extracted by mini-css-extract-plugin
export default {"DataFieldContainer":"Scenes_DataFieldContainer__TeXrc","DataFieldContainerSmall":"Scenes_DataFieldContainerSmall__yaLv4"};